import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { StarterDashboardV2RootPageDataQuery } from '../rootPageData.graphql';

type Petition = NonNullable<StarterDashboardV2RootPageDataQuery['petition']>;
export function getPetitionTotalViews(petition: Petition, i18n: UtilityContext['i18n']) {
	// `petition.viewCount` only tracks page views, so we add views from impressions across the site too
	const totalViews = petition.viewCount + (petition.promotionStats?.impressionsServed ?? 0);
	const totalViewsLocalized = i18n.localizeNumber(totalViews);

	return { totalViews, totalViewsLocalized };
}
